import angular from 'angular';
import { sum } from 'lodash';

module.exports = angular.module('common.filters.sum', [])
.filter('sum', function() {
  return sum;
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/sum.js
 **/